const DEVICE_ID_KEY = 'sparxmate_hmrc_device_id';

/**
 * Persistent browser device ID for Gov-Client-Device-ID.
 * @returns {string}
 */
export function getHmrcDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id =
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `spx-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return `spx-fallback-${Date.now()}`;
  }
}

/**
 * Build fraud-prevention context from the browser for HMRC API calls.
 * @param {string} [userId]
 * @returns {Record<string, string>}
 */
export function buildHmrcFraudContext(userId) {
  const timezone =
    typeof Intl !== 'undefined' && Intl.DateTimeFormat
      ? Intl.DateTimeFormat().resolvedOptions().timeZone || ''
      : '';

  let screenInfo = '';
  try {
    if (typeof screen !== 'undefined') {
      screenInfo = `width=${screen.width}&height=${screen.height}&scaling-factor=1&colour-depth=${screen.colorDepth}`;
    }
  } catch {
    screenInfo = '';
  }

  let windowSize = '';
  try {
    if (typeof window !== 'undefined') {
      windowSize = `width=${window.innerWidth}&height=${window.innerHeight}`;
    }
  } catch {
    windowSize = '';
  }

  const ctx = {
    deviceId: getHmrcDeviceId(),
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent || '' : '',
    timezone,
    screenInfo,
    windowSize,
  };

  if (userId) {
    const payload = [{ key: 'sparxmate', value: String(userId) }];
    ctx.userIds = btoa(JSON.stringify(payload));
  }

  return ctx;
}
